export default "__VITE_ASSET__BVpLcEaz__"